module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/sat/sections/apps/assets/prep_app-f4a73e7555712a6943a3621aa6c3335f.png";